
import { EntProductsFilter } from "../../../models/filters/productsFilter";
import { EntProduct } from "../../../models/product";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
export const productApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductList: builder.query<ResponseDataGet<EntProduct>, EntProductsFilter>({
      query: (filter) => ({
        url: "/product/get-all",
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getProductById: builder.query<ResponseDataTest<EntProduct>, number>({
      query: (id) => ({
        url: `/product/${id}`,
        method: 'GET'
      })
    }),
    addProduct: builder.mutation<ResponseDataTest<EntProduct>, EntProduct>({
      query: (body) => ({
        url: `/product`,
        method: "POST",
        body: JSON.stringify(body)
      }),
      onQueryStarted: async (user, { dispatch, queryFulfilled }) => {
        try {
        } catch { }
      }
    }),
    editProduct: builder.mutation<ResponseDataTest<EntProduct>, EntProduct>({
      query: (body,) => ({
        url: `/product`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
      onQueryStarted: async (user, { dispatch, queryFulfilled }) => { }
    }),
    deleteProduct: builder.mutation<ResponseDataTest<EntProduct>, number>({
      query: (id) => ({
        url: `/product/${id}`,
        method: 'DELETE',
      }),
      onQueryStarted: async (id, { dispatch, queryFulfilled }) => { }
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddProductMutation,
  useDeleteProductMutation,
  useEditProductMutation,
  useGetProductByIdQuery,
  useLazyGetProductListQuery
} = productApi;
